export default __webpack_public_path__ + "static/media/donations-reversed.cb30488e.svg";